import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class Gallery extends Component {
  onInit( el, args) {
    // Initializations
    this.loadMore = this.loadMore.bind( this );

    this.el = el;
    this.galeries = this.el.querySelectorAll('.js-single-gallery');
    this.loadmore = this.el.querySelectorAll('.js-loadmore-gallery');
  }

  onReady() {
    if (this.loadmore) {
      for (var i = 0; i < this.loadmore.length; i++) {
        this.loadmore[i].addEventListener( device.pointerdown, this.loadMore );
      }
    }

    // Comment récup le dernier item ?
    jQuery('.fplive-gallery').last().addClass('margin-bottom-xl');
  }

  loadMore(e) {
    e.currentTarget.parentNode.classList.add('hide');

    for (var i = 0; i < this.galeries.length; i++) {
      if (this.galeries[i].classList.contains('hide')) {
        this.galeries[i].classList.remove('hide');
        this.galeries[i].classList.add('show');
      }
    }
  }
}